<template>
	<div class="cmpnt-box">
		<header class="lmy-search-header search-header">
	        <i class="iconfont icon-yuyin" @click="data.show=false"></i>
			<div class="search-text" style="margin-left:.2rem" >
				<svg class="icon" aria-hidden="true">
					<use xlink:href="#icon-sousuo"></use>
				</svg>
				<input type="text" placeholder="行政区/商圈/关键词/酒店" v-model="key" readonly="readonly" @click="shData.show=true"/>
			</div>
	    </header>

		<div class="lmy-shop">
		    <div class="lmy-shop-list" v-for="item in LandmarkGroupsData">
		        <div class="shop-list-head">
		            <div class="head-icon shop-address-icon"><i class="iconfont icon-location"></i></div>
		            {{item.GroupName}}
		            <div class="shop-more" v-if="item.Landmarks.length>12" @click="loadMoreLandmark(item)">更多 >></div>
		        </div>
		        <ul class="shop-list" >
		            <li class="list-item" v-for="(lm,index) in item.Landmarks" @click="select(lm,item.GroupName)" v-if="index<12">{{lm.Name}}</li>
		           
		        </ul>
		    </div>
		</div>
		<transition  name="slide" >
			<LandMarkMore :lmData="lmData" @select="lmData.select" v-if="lmData.show" ></LandMarkMore>
		</transition>
		<transition  name="slide" >
			<SearchHotel @select="shData.select" :RegionID="RegionID" :shData="shData" :from="from"  v-if="shData.show" ></SearchHotel>
		</transition>
	</div>
	
</template>
<script>
	import LandMarkMore from './landMarkMore.vue'//更多地标
	import SearchHotel from './searchHotel.vue'//搜索酒店
	export default{
		name:'hotPlace',
		components:{
			LandMarkMore,
			SearchHotel
		},
		props:{
			hotelData:{
				type:Object,
				default:()=>{
					return {}
				}
			},
			RegionID:{
				type:String,
				default:''

			},
			from:{
				type:Number,
				default:1

			},
			LandmarkGroups:{
				type:Array,
				default:()=>{
					return []
				}
			}
		},
		data(){
			return{
				data:{},
				key:'',
				LandmarkGroupsData:[],
				lmData:{
					show:false,
					RegionID:this.RegionID,
					GroupName:'',
					from:this.from,
					group:'',
					select:(val)=>{
						this.lmData.show=false;
						this.$emit('landmark',val)
					}
				},
				shData:{
					show:false,
					From:this.from,
					select:(val)=>{
						this.shData.show=false;
						var obj={
							Name:'',
							hotelName:val,
							ID:''
						}
						this.$emit('landmark',obj);
					}
				},
			}
		},
		watch:{
			hotelData(val){
				this.data=val;
				
				this.shData.From=val.from;
				this.lmData.from=val.from;
			},
			RegionID(val){
				this.lmData.RegionID=val;
				this.getLandmarkGroups();

			},
			from(val){
				this.lmData.from=val;
				this.lmData.From=val;

			},
			key(val){
				if(!val){
					this.LandmarkGroupsData=this.LandmarkGroups;
					return;
				}
				var that=this;
   				var params={
                    isCN:hotelData.from==1?true:false,
                    pid:that.RegionID,
                    q:val,
                    group:'',
                    pageSize:10,
                }
                that.getRequest({
                    url: that.Api.getLandmarkGroups,
                    params: params
                }).then(res => {
                    if(res&&res.IsSuccess){
                    	that.LandmarkGroupsData=res.Result;
                    }
                });
		   	},
		},
		methods:{
			getLandmarkGroups(){
                var that=this;
                
                var params={
                    isCN:this.from==1?true:false,
                    pid:that.RegionID,
                    q:'',
                    group:'',
                    pageSize:13,
                }
                that.getRequest({
                    url: that.Api.getLandmarkGroups,
                    params: params
                }).then(res => {
                    if(res&&res.IsSuccess){
                        that.LandmarkGroupsData=res.Result;
                    }
                });
            },
			loadMoreLandmark(lm){
				this.lmData.group=lm.GroupID;
				this.lmData.GroupName=lm.GroupName;
				this.lmData.show=true;
				

			},
			select(lm,GroupName){
				
				this.$emit('landmark',lm,GroupName)
			}			
		},
		mounted(){
			this.data=this.hotelData;
			this.getLandmarkGroups();
			
			// this.LandmarkGroupsData=this.LandmarkGroups;
			// console.log(this.LandmarkGroupsData);
			// if(!this.LandmarkGroupsData||this.LandmarkGroupsData.length<1){
			// 	this.getLandmarkGroups();
			// }


		}
	}












	
</script>


// WEBPACK FOOTER //
// src/components/common/cmpnt/hotPlace.vue